import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        width: "100%",
        height: "100%",
        justifyContent: "space-between",
    },
    title: {
        fontSize: "35px",
        lineHeight: "41px",
        paddingBottom: "32px",
    },
    body: {
        flex: 4,
        display: "flex",
        flexDirection: "column",
        width: "70%",
    },
    bodyText: {
        fontSize: "20px",
        lineHeight: "30px",
        textOverflow: "initial",
        overflow: "hidden",
    },
    content: {
        height: "400px",
        display: "flex",
        flex: 1,
        alignSelf: "center",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: "40px",
        width: "80%",
    },
    upperBody: {
        flex: 5,
        display: "flex",
        flexDirection: "column",
    },
    bottomBody: {
        flex: 0.5,
        display: "flex",
    },
}));
export default useStyles;
